<template>
  <shop-detail :is-edit='false'>
  </shop-detail>
</template>

<script>
import ShopDetail from './components/ShopDetail'
export default {
  name: 'CreateShop',
  components: {
    ShopDetail
  }
}
</script>

